<template>
  <a-modal v-model:open="visible" :width="width" :title="title" @cancel="handleClear" @ok="cropOk" :class="className">
    <a-row :gutter="10">
      <a-col :span="17" :style="{ height: height + 'px' }">
        <vue-cropper ref="$cropper" class="cropper" :img="img" :output-type="type" :can-move="true" :can-move-box="true"
          :fixed-box="true" :auto-crop="true" :auto-crop-width="autoCropWidth" :auto-crop-height="autoCropHeight"
          :max-img-size="1000" @realTime="getCropdata" />
      </a-col>
      <a-col :span="7">
        <div style="width: 200px; height: 165px; border: 1px solid #e9e9e9; border-radius: 2px">
          <a-image :src="previewUrl" />
        </div>
      </a-col>
    </a-row>
    <div style="text-align: center; padding-top: 10px">
      <a-space>
        <a-button @click="$cropper.changeScale(1)">放大</a-button>
        <a-button @click="$cropper.changeScale(-1)">缩小</a-button>
        <a-button @click="$cropper.rotateLeft()">向左旋转</a-button>
        <a-button @click="$cropper.rotateRight()">向右旋转</a-button>
      </a-space>
      <div style="padding-top: 10px">
        <a-upload name="file" :show-upload-list="false" :custom-request="() => { }"
          accept="image/png, image/jpeg, image/gif, image/jpg" @change="uploadChange">
          <a-button type="primary">
            <huasky-icon icon="UploadOutlined" />
            点击上传图片
          </a-button>
        </a-upload>
      </div>
      <div style="padding-top: 10px" class="desc">请上传图片文件，建议不超过2M</div>
    </div>
  </a-modal>
</template>
<script setup lang="ts">
// 图片裁剪上传组件
import { ref } from 'vue'

const props = defineProps<{
  title: string,
  width: number,
  height: number,
  imgSrc: string,
  type: string,
  autoCropWidth: number,
  autoCropHeight: number,
  className?: string
}>()
const emit = defineEmits(['finish'])
const visible = ref(false)              // 模态框的隐藏于显示
const previewUrl = ref('')              // 预览的图片

const $cropper = ref()                  // 裁剪组件
const img = ref(props.imgSrc)           // 图片

const handleClear = () => {             // 关闭模态框，并将裁剪组件还原
  visible.value = false
  previewUrl.value = ''
}
const cropOk = () => {                  // 提交
  $cropper.value.getCropBlob((blobData: Blob) => {
    const data = { fileName: 'file.png', blobData: blobData, url: previewUrl.value }
    emit('finish', data)
    handleClear()
  })
}

const getCropdata = () => {             // 实时裁剪，在预览组件中显示
  $cropper.value.getCropData((data: any) => {
    previewUrl.value = data
  })
}
const uploadChange = (obj: any) => {
  getBase64(obj.file.originFileObj, (imageUrl: string) => {
    img.value = imageUrl
  })
}

const getBase64 = (img: Blob, callback: Function) => {
  const reader = new FileReader()
  reader.addEventListener('load', () => callback(reader.result))
  reader.readAsDataURL(img)
}

/**
 * 打开裁剪框
 * @param 文件地址或base64 
 */
const show = (source?: string) => {
  visible.value = true
  img.value = source ?? ''
}

defineExpose({
  show
})

</script>
<style lang="scss" scoped>
.circle {
  border-radius: 50%;
}

.cropper {
  height: 280px;
}
</style>